module.exports = __webpack_public_path__ + "img/about-user-img.6a72a9c7.png";